angular.module('tasks.meeting-attendance', ['tasks'])
    .factory('TaskMeetingAttendance', function ($resource) {
        return $resource('/crm/api/task/:id/attendance/:userId/:action', {id: "@id", userId: "@userId", action: "@action"}, {
            get: {method: 'GET'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            statuses: {method: 'GET', url: '/crm/api/task-meeting-attendance-status', isArray: true},
            action: {method: 'POST'},
            logs: { url: '/crm/api/task/:id/attendance-logs', isArray: true }
        });
    })
    .service('TaskMeetingAttendanceService', function ($http, $rootScope, toastr, modals, TaskMeetingAttendance, Principal) {
        this.accept = (id, userId) => {
            return TaskMeetingAttendance.action({id: id, action: 'accept', userId: userId}).$promise.then(() => {
                toastr.success("Zapisano");
                $rootScope.$broadcast('task.updated')
            })
        };
        this.note = (id, userId) => {
            return TaskMeetingAttendance.action({id: id, action: 'note', userId: userId}).$promise.then(() => {
                toastr.success("Zapisano");
                $rootScope.$broadcast('task.updated')
            })
        };
        this.reject = (id, userId) => {
            return modals.open('app/task/meeting-attendance/reject.html', 'TaskMeetingAttendanceRejectController', {id: id, userId: userId}, {size: "sm"}, "$ctrl")
        };
        this.cancel = (id, userId) => {
            return TaskMeetingAttendance.action({id: id, action: 'cancel', userId: userId}).$promise.then(() => {
                toastr.success("Zapisano");
                $rootScope.$broadcast('task.updated')
            })
        };
        this.logs = (id) => {
            return modals.open('app/task/meeting-attendance/logs.html', 'TaskMeetingAttendanceLogsController', {id: id}, {size: "sm"}, "$ctrl")
        };
    })
